__turbopack_context__.v({
  "container": "DeviceCheck-module-scss-module__fgap4a__container",
});
